import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useStateContext } from "../../../../../contexts/ThemeContext";
// import LinkIcon from "../../../../../assets/MainPage/link.png";

import { ReactComponent as LinkIcon } from "../../../../../assets/dashboard/link/linkIcon.svg";
import { ReactComponent as LinkIconDark } from "../../../../../assets/dashboard/link/linkIcon-dark.svg";

import { ReactComponent as TrashIcon } from "../../../../../assets/dashboard/link/trashIcon.svg";
import { ReactComponent as TrashIconDark } from "../../../../../assets/dashboard/link/trashIcon-dark.svg";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import ExtraSmallFilledButton from "../../../../../components/common/buttons/ExtraSmallFilledButton";
import useLocales from "../../../../../hooks/useLocales";
import { ReactComponent as DownArrow } from "../../../../../assets/settingPage/arrow-down.svg";
import { useSelector } from "react-redux";
import { I18nextProvider } from "react-i18next";
import i18nForComponent from "../../../../../locales/component/i18nForComponent";

// This Form component is responsible for add and edit Media Blocks

const MediaForm = ({
  updateMediaLink,
  isLoading,
  preHeaderData,
  formType,
  handleDelete,
  onSubmitMdiaLink,
}) => {
  const { darkMode } = useSelector((state) => state.theme);

  const { allLangs, tComponent, handleLanguageChange } = useLocales();

  const { setActiveMainPageNav } = useStateContext();
  const { media } = useParams();

  const [selectReporterTypeDropDown, setSelectReporterTypeDropDown] =
    useState(false);
  const [selectedReporterType, setSelectedReporterType] = useState("English");
  const [selectedLang, setSelectedLang] = useState("en");

  useEffect(() => {
    setActiveMainPageNav(true);
    return () => {
      setActiveMainPageNav(false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (selectedLang) {
      handleLanguageChange(selectedLang);
    }
  }, [selectedLang]);

  const [registerSchema, setRegisterSchema] = useState();

  useEffect(() => {
    if (media === "youtube") {
      setRegisterSchema(
        Yup.object().shape({
          coloum_value: Yup.string()
            .required("URL Required")
            .matches(
              /^(http(s)??:\/\/)?(www\.)?((youtube\.com\/watch\?v=)|(youtu.be\/))([a-zA-Z0-9\-_])+/,
              "Enter a valid URL"
            ),
        })
      );
    } else if (media === "twitter") {
      setRegisterSchema(
        Yup.object().shape({
          coloum_value: Yup.string()
            .required("URL Required")
            .matches(
              /((https?):\/\/)?(www.)?twitter\.com(\/@?(\w){1,15})\/status/,
              "Enter a valid URL"
            ),
        })
      );
    } else if (media === "instagram") {
      setRegisterSchema(
        Yup.object().shape({
          coloum_value: Yup.string()
            .required("URL Required")
            .matches(
              /(?:(?:http|https):\/\/)?(?:www.)?(?:instagram.com|instagr.am|instagr.com)\/(\w+)/,
              "Enter a valid URL"
            ),
        })
      );
    } else if (media === "tiktok") {
      setRegisterSchema(
        Yup.object().shape({
          coloum_value: Yup.string()
            .required("URL Required")
            .matches(
              /https?:\/\/(?:www\.)?tiktok\.com\/@([^/]+)\/video\/(\d+)/,
              "Enter a valid URL"
            ),
        })
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [media]);

  const {
    reset,
    register,
    setValue,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(registerSchema || Yup.object()), // Provide a default schema if registerSchema is undefined
  });

  const onSubmit = async (data) => {
    if (formType === "add") {
      if (media === "instagram") {
        if (data.coloum_value && data.coloum_value.includes("?")) {
          // Split the URL by the '?' character and take the part before it
          const trimmedUrl = data.coloum_value.split("?")[0];
          data.coloum_value = trimmedUrl;
        }
      }
      data.language = selectedLang;
      onSubmitMdiaLink(data);
    } else {
      if (media === "instagram") {
        if (data.coloum_value && data.coloum_value.includes("?")) {
          // Split the URL by the '?' character and take the part before it
          const trimmedUrl = data.coloum_value.split("?")[0];
          data.coloum_value = trimmedUrl;
        }
      }
      data.language = selectedLang;
      updateMediaLink(data);
    }
  };

  useEffect(() => {
    const headerValue = preHeaderData?.data?.coloum_value;
    if (preHeaderData) {
      setValue("coloum_value", JSON.parse(headerValue).coloum_value);
      setSelectedLang(preHeaderData?.data?.language);
      const matchedLang = allLangs?.find(
        (lang) => lang.value === preHeaderData?.data?.language
      );
      const shouldSetLang = matchedLang?.label;
      setSelectedReporterType(shouldSetLang);
      handleLanguageChange(preHeaderData?.data?.language);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [preHeaderData]);

  const deleteHandler = async (data) => {
    if (formType === "edit") {
      handleDelete(data);
    } else {
      reset();
    }
  };

  const handleChangeLang = (newLang) => {
    handleLanguageChange(newLang);
  };

  return (
    <I18nextProvider i18n={i18nForComponent}>
      <>
        <div
          className="sm:mt-7 md:px-0 mt-10 mb-6 px-6"
          style={{
            direction: selectedLang === "ar" ? "rtl" : "ltr",
          }}
        >
          <div className="border rounded-lg bg-light_bg_v5 dark:bg-dark-secondary p-[25px] dark:border-color_dark">
            <div className="flex justify-between items-center mb-[20px] sm:mb-[25px]">
              <p className="text-small2_b sm:text-small1_bold text-heading_color dark:text-color_v1_dark uppercase">
                {media}
              </p>
              {formType === "add" && (
                <div className="flex items-center justify-center">
                  <div className="relative w-[115px] sm:w-[145px]">
                    <div
                      onClick={() => {
                        setSelectReporterTypeDropDown(
                          !selectReporterTypeDropDown
                        );
                      }}
                      className={`bg-light_bg_v4 capitalize p-[13px] text-small2 lg:text-body_copy2 rounded-md w-full flex justify-between items-center cursor-pointer`}
                    >
                      {selectedReporterType
                        ? selectedReporterType
                        : tComponent("media.select_lang")}
                      <DownArrow />
                    </div>
                    {selectReporterTypeDropDown && (
                      <div className="absolute top-14 mb-20 left-0 w-full z-50 p-[7px] px-[10px] md:p-[15px] bg-light_bg_v5  rounded-lg border flex flex-col max-h-40 overflow-y-auto">
                        {allLangs?.map((item, i) => {
                          return (
                            <div
                              key={i}
                              onClick={() => {
                                setSelectedLang(item.value); // Set selected language code
                                setSelectedReporterType(item?.label);
                                setSelectReporterTypeDropDown(false);
                                handleChangeLang(item?.value);
                              }}
                              className="px-[10px] md:px-[15px] py-[7px] md:py-[10px] capitalize text-small2 lg:text-body_copy2 text-heading_color cursor-pointer hover:bg-light_bg_v4 rounded-md"
                            >
                              {item.label}
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </div>
                </div>
              )}
              {formType === "edit" && (
                <div
                  className={`w-[100px] bg-light_bg_v4 capitalize p-[10px] text-small2 lg:text-body_copy2 rounded-md flex justify-center items-center`}
                >
                  {selectedReporterType ? selectedReporterType : "English"}
                </div>
              )}
            </div>
            <form onSubmit={handleSubmit((data) => onSubmit(data))}>
              <div className="mt-[20px] sm:mt-[25px]">
                <div>
                  <div className="mt-3 relative">
                    <div className="absolute inset-y-0 h-full sm:ps-[10px] ps-[16px] flex justify-center items-center">
                      {darkMode ? <LinkIconDark /> : <LinkIcon />}
                    </div>
                    <input
                      type="text"
                      id="heading"
                      {...register("coloum_value")}
                      className={`rounded-md border  bg-light_bg_v5 p-[13px] sm:p-[11px] py-[5px] sm:py-[3px] ps-[42px] sm:ps-[36px] px-[14px] sm:px-[16.5px] text-heading_color text-small2 sm:text-small1 focus:outline-none focus:ring-0 focus:placeholder:text-heading_color block w-full dark:bg-dark-secondary dark:text-color_v1_dark placeholder:dark:text-font_light_color dark:caret-white focus:placeholder:dark:text-color_v1_dark
                    ${
                      errors?.coloum_value
                        ? "border-state_color_error dark:bg-dark-secondary"
                        : "border-light_bg_v2 focus:border-font_light_color dark:border-color_dark focus:dark:border-font_color"
                    }
                    `}
                      placeholder={tComponent("media.enter_link") + " URL"}
                    />
                  </div>
                  {errors?.coloum_value && (
                    <small className="text-state_color_error text-small3">
                      {errors?.coloum_value?.message}
                    </small>
                  )}
                </div>
              </div>
              <div className="flex mt-[26px] items-center justify-end">
                <button
                  type="button"
                  onClick={() => deleteHandler()}
                  className="flex justify-center items-center"
                >
                  {darkMode ? <TrashIconDark /> : <TrashIcon />}
                  <p className="ps-1.5 pt-1 text-small3_b gray-700 text-heading_color dark:text-color_v1_dark">
                    {tComponent("media.delete_cap")}
                  </p>
                </button>

                <ExtraSmallFilledButton
                  buttonType={"submit"}
                  isLoading={isLoading}
                  name={`${tComponent("media.save_cap")}`}
                  classes={"ms-3"}
                />
              </div>
            </form>
          </div>
        </div>
      </>
    </I18nextProvider>
  );
};

export default MediaForm;
